/**
 * Translates a duration in seconds to a human readable format.
 *
 * You can use the following format specifiers:
 * <ul>
 * <li><code>%h</code> for Hours</li>
 * <li><code>%m</code> for Minutes</li>
 * <li><code>%s</code> for Seconds</li>
 * </ul>
 *
 * The formatters can be repeated to pad the output.
 * For example, <code>'%m'</code> will return '1' if you pass 60 seconds,
 * while <code>'%mm'</code> will left pad the output and return '01'.
 *
 * @param {number} duration The duration in seconds
 * @param {string} [opt_format] The output format
 * @returns {string} The formated duration as a string
 * @export
 */
export function durationToString (duration, opt_format = '%hh:%mm:%ss') {
    if (duration === null || duration === undefined) {
      duration = 0;
    }
    if (opt_format === null || opt_format === undefined) {
      opt_format = '%h:%mm:%ss';
    }
    let hours = Math.floor(duration / 3600);
    let minutes = Math.floor((duration - (hours * 3600)) / 60);
    let seconds = Math.floor(duration - (hours * 3600) - (minutes * 60));

    let pad = (str, max) => str.length < max ? pad('0' + str, max) : str;
    let replacer = (value) => (_, group) => pad(value, group.length - 1);

    return opt_format
      .replace(/(%h+)/, replacer(String(hours)))
      .replace(/(%m+)/, replacer(String(minutes)))
      .replace(/(%s+)/, replacer(String(seconds)));
  }

